module.exports = __webpack_public_path__ + "am.svg?1fd89addafc345e49acdd16000d3c632";